import ApiService from "@/services/base";
import { config } from "@/utils/config";
let DashboardService = class DashboardService extends ApiService {
    constructor(){
        super({
            baseURL: config.apiUrl
        });
    }
    async getDashboardData(chartDays = 30, customerId) {
        const params = new URLSearchParams();
        params.append("chartDays", String(chartDays));
        if (customerId) {
            params.append("customerId", customerId);
        }
        const response = await this.get({
            url: `/direct/dashboard?${params.toString()}`
        });
        return response.data;
    }
};
export default DashboardService;
